// React Dependencies
import React, { Component } from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Typography, Chip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { DropzoneArea } from 'material-ui-dropzone';
import { toast } from 'react-toastify';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

// Internal Dependencies
import { IsEmpty } from '../../common/checks';
import Constants from '../../common/constants';
import FixedCropper from '../global/image/FixedCropper';
import OverLoading from '../global/OverLoading';
import apiService from '../../services.js/apiService';
import SortableMedia from '../global/SortableMedia/SortableMedia';
import { convertDataURLtoBlob } from '../../common/util';

const useStyles = () => ({
  myDropZone: {
    position:        'relative',
    width:           '30%',
    height:          '10%',
    minHeight:       '50px',
    backgroundColor: '#ffffff',
    border:          0,
    boxShadow:       '0px 0px 1px 0px rgba(0, 0, 0, 1)',
    borderRadius:    5,
    borderColor:     '#000000',
    cursor:          'pointer',
    boxSizing:       'border-box',
  },
});

class Photos extends Component {
  constructor(props) {
    super(props);
    this.dropZoneRef = null;
    this.state = {
      mediaData:       '',
      alert:           false,
      openCropDialog:  false,
      uploadUrl:       '',
      base64:          '',
      type:            null,
      src:             null,
      originalFile:    null,
      images:          [],
      tempImgToDelete: [],
      currentFile:     null,
      viewImage:       '',
      cropping:        false,

      view:    false,
      loading: false,
    };

    this.maxFileSize = 7340032;
    this.imageFormats = ['image/jpeg', 'image/jpg', 'image/png'];

    this.handleSave = this.handleSave.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.getBase64Image = this.getBase64Image.bind(this);
    this.handleView = this.handleView.bind(this);
    this.handleCrop = this.handleCrop.bind(this);
    this.handleUploadMultipleFile = this.handleUploadMultipleFile.bind(this);
  }

  componentDidMount() {
    const fetchReview = async () => {
      const review = await apiService.getReview(this.props.reviewId);
      if (!IsEmpty(review)) {
        this.setState({ images: review.images });
      }
    };

    if (!IsEmpty(this.props.images)) {
      this.setState({ images: this.props.images });
    } else {
      fetchReview();
    }
  }

  handleClose = () => {
    this.setState({ openCropDialog: false, currentFile: null, alert: false, base64: '', view: false, type: null, uploadUrl: '', cropping: false, tempImgToDelete: [] });
  }

  handleErrorMessage(file, format) {
    if (!IsEmpty(file) && !IsEmpty(format)) {
      if (format === 'image') {
        if (!this.imageFormats.includes(file.type)) {
          toast.error('Only JPG, JPEG and PNG files are supported.');
          return false;
        }

        if (file.size > this.maxFileSize) {
          toast.error('Maximum file size of 7MB exceeded.');
          return false;
        }
      } else if (file.size > this.maxPDFFileSize) {
          toast.error('Maximum file size of 15MB exceeded.');
          return false;
      }
      return true;
    }
  }

  getBase64Image = (imgUrl, callback) => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // eslint-disable-next-line func-names
    img.onload = function () {
      canvas.width = img.width;
      canvas.height = img.height;

      ctx.drawImage(img, 0, 0);

      let dataURL = canvas.toDataURL('image/png');
      dataURL = dataURL.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
      callback(dataURL); // the base64 string
    };

    if (img.complete) {
      img.crossOrigin = Constants.CrossOrigin;
      img.src = imgUrl;
    }
  }

  handleUpload(file) {
    if (!IsEmpty(file)) {
      if (file.length === 1) {
        this.setState({ openCropDialog: true, type: 'upload' }, () => {
          if (this.state.openCropDialog) {
            this.setState({ currentFile: file[0] }, () => {
              const reader = new FileReader();
              reader.addEventListener('load', () => {
                this.setState({ src: reader.result });
                const originalImageBlob = convertDataURLtoBlob(reader.result);
                this.setState({ originalFile: new File([originalImageBlob], 'o.jpeg', { type: 'image/jpeg' }) });
              });
              reader.readAsDataURL(this.state.currentFile);
            });
          }
        });
        this.dropZoneRef.updater.enqueueSetState(this.dropZoneRef, { fileObjects: [] });
      } else {
        this.handleUploadMultipleFile(file);
      }
    }
  }

  b64toBlob = (dataURI) => {
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i += 1) { ia[i] = byteString.charCodeAt(i); }

    return new Blob([ab], { type: 'image/jpeg' });
  }

  handleCrop = (image) => {
    let uploadUrl = image.original;
    if (typeof image.originalFile === 'object') {
      uploadUrl = URL.createObjectURL(image.originalFile);
    }
    const cacheFreeURL = `${uploadUrl}?v=${new Date().getTime()}`;

    const temp = [];
    this.setState({ uploadUrl: cacheFreeURL, cropping: true }, () => {
        temp.push(image);
        this.setState({ tempImgToDelete: temp }, () => {
            this.handleUploadUrl();
        });
    });
  };

  handleUploadUrl = () => {
    this.getBase64Image(this.state.uploadUrl, (base64image) => {
      this.setState({ openCropDialog: true, base64: base64image, type: 'url', currentFile: null },
      () => {
        const imgFile = this.b64toBlob(`data:image/*;base64,${this.state.base64}`);
        this.setState({ src: `data:image/*;base64,${this.state.base64}`, originalFile: new File([imgFile], 'o.jpeg', { type: 'image/jpeg' }) });
      });
    });
  }

  handleSave = async (file) => {
    try {
      if (file) {
        const tempReviewImages = this.state.images;
        const formData = new FormData();
        formData.append('image', file);
        formData.append('image', this.state.originalFile);
        formData.append('type', 'images');

        if (this.state.cropping && !IsEmpty(this.state.tempImgToDelete)) {
          if (!IsEmpty(this.state.tempImgToDelete[0].originalFile)) {
            const index = this.state.images.findIndex((image) => image.originalFile && (this.state.tempImgToDelete[0].originalFile === image.originalFile));
            const finalArrayOfImages = this.state.images;

            const uploadedIndex = [];

            _.map(this.state.images, (img, i) => {
              if (!IsEmpty(img.display)) {
                uploadedIndex.push(i);
              }
            });

            formData.append('uploadedIndex', uploadedIndex);
            formData.append('imgIndex', index);

            const result = await apiService.uploadReviewMedia(this.props.reviewId, formData, file);
            finalArrayOfImages.splice(index, 1, result);

            if (result) {
              const review = await apiService.getReview(this.props.reviewId);
              if (review) {
                this.setState({
                  images:         finalArrayOfImages,
                  openCropDialog: false,
                  cropping:       false,
                  currentFile:    null,
                  src:            null,
                  type:           null,
                  uploadUrl:      '',
                  base64:         '',
                }, () => {
                  this.props.onReviewImageChange(this.state.images);
                  if (IsEmpty(this.props.image)) {
                    this.props.onImageChange(this.state.images[0].display);
                  }
                });
              }
            }
          } else {
            const [croppedImg] = this.state.tempImgToDelete;

            formData.append('original', croppedImg.original);
            const result = await apiService.uploadReviewMedia(this.props.reviewId, formData, file);

            if (!IsEmpty(result)) {
              const updatedImages = _.map(
                tempReviewImages,
                (img) => (img.original === croppedImg.original ? result : img),
              );
              this.setState({
                images:         updatedImages,
                openCropDialog: false,
                cropping:       false,
                currentFile:    null,
                src:            null,
                type:           null,
                uploadUrl:      '',
                base64:         '',
              }, () => this.props.onReviewImageChange(updatedImages));
            }
          }

          toast.success('Image cropped successfully.');
        } else {
          const result = await apiService.uploadReviewMedia(this.props.reviewId, formData, file);
          if (result) {
            this.setState({
              images:         this.state.images.concat(result),
              openCropDialog: false,
              cropping:       false,
              currentFile:    null,
              src:            null,
              type:           null,
              uploadUrl:      '',
              base64:         '',
            }, () => {
              this.props.onReviewImageChange(this.state.images);
              toast.success('Image uploaded successfully.');
              if (IsEmpty(this.props.image)) {
                this.props.onImageChange(result.display);
              }
            });
          }
        }
      }
    } catch (err) {
      toast.error(err.message);
    }
  }

  handleView = (image) => {
    let viewImage = image.original;

    if (typeof image.originalFile === 'object') {
      viewImage = URL.createObjectURL(image.originalFile);
    }

    this.setState({ view: true, viewImage });
  }

  handleUploadMultipleFile = async (files) => {
    const currentImages = this.state.images;

    for (let i = 0; i < files.length; i += 1) {
      currentImages.push({ display: null, originalFile: files[i] });
    }

    this.setState({ images: currentImages }, () => {
      this.props.onReviewImageChange(this.state.images);
    });
    this.dropZoneRef.updater.enqueueSetState(this.dropZoneRef, { fileObjects: [] });
  }

  handleDelete = async () => {
    try {
      if (!IsEmpty(this.state.mediaData.originalFile)) {
        const index = this.state.images.findIndex((image) => image.originalFile && (this.state.mediaData.originalFile === image.originalFile));
        const finalArrayOfImages = this.state.images;
        finalArrayOfImages.splice(index, 1);
        this.setState({
          images: finalArrayOfImages,
          alert:  false,
        });

        return;
      }

      let tempImgToDeleteData = this.state.mediaData;
      if (this.state.cropping === true && !IsEmpty(this.state.tempImgToDelete)) {
        [tempImgToDeleteData] = this.state.tempImgToDelete;
        this.setState({ mediaData: tempImgToDeleteData });
      }

      const response = await apiService.deleteReviewMedia(this.props.reviewId, { mediaData: tempImgToDeleteData, fileType: Constants.FileType.Image });
      if (response) {
        const images = this.state.images.filter((image) => {
          if (image.display) {
            return image.display !== this.state.mediaData.display;
          } else {
            return image.original !== this.state.mediaData.original;
          }
        });
        this.setState({ images, alert: false }, () => {
          this.props.onReviewImageChange(this.state.images);
          if (IsEmpty(this.props.image) && IsEmpty(this.state.images) || IsEmpty(this.state.images)
            && !IsEmpty(this.props.image)) {
            // related to videos part
            // && !this.props.image.includes('thumbnails/')){
            this.props.onImageChange(null);
          }
          if (!IsEmpty(this.state.images) && IsEmpty(this.props.image)) {
            this.props.onImageChange(images[0].display);
          }
          if (!IsEmpty(this.state.images) && !IsEmpty(this.props.image) && this.state.images !== this.props.images) {
            this.props.onImageChange(images[0].display);
          }
        });

        toast.success('Image successfully deleted.');

        return images;
      } else {
        this.setState({ alert: false });
        toast.error('An unexpected error has occurred');
      }
    } catch (err) {
      toast.error(err.message);
    }
  }

  handleConfirmation = (mediaData) => {
    this.setState({ alert: true, mediaData });
  }

  handleSort = (images) => {
    this.setState({ loading: true, images }, () => {
      this.props.onSortImage(images);
      this.handleUpdate();
    });
  }

  handleUpdate = async () => {
    try {
      const payload = {
        images: this.state.images,
      };
      await apiService.updateReview(this.props.reviewId, payload);
      this.setState({ loading: false }, () => {
        // comment this since it related to video part
        // // if(!this.props.image.includes('thumbnails/')){
        //   this.props.onImageChange(payload.images[0].display)
        // }
          this.props.onImageChange(payload.images[0].display);
        toast.success('Image position updated');
      });
    } catch (err) {
      toast.error(err.message);
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        {this.state.loading && <OverLoading />}
        <h5>Images</h5>
        <center>
          <DropzoneArea
            ref={(ref) => {
              this.dropZoneRef = ref;
            }}
            dropzoneText="Click to upload image"
            onChange={this.handleUpload.bind(this)}
            dropzoneClass={classes.myDropZone}
            showPreviewsInDropzone={false}
            showPreviews={false}
            showAlerts={false}
            clearOnUnmount
            getDropRejectMessage={(file) => this.handleErrorMessage(file, 'image')}
            filesLimit={15}
            maxFileSize={this.maxFileSize}
            acceptedFiles={this.imageFormats}
          />
        </center>

        {!IsEmpty(this.state.images) && (
          <Chip
            style={{
              backgroundColor: 'rgba(255,255,255,0)',
              width:           '150px',
              verticalAlign:   'bottom',
              margin:          '0px 0px -40px 35px',
            }}
            label={<Typography variant="h1">Cover Image</Typography>}
          />
        )}

        {!IsEmpty(this.state.images) && (
          <div style={{ position: 'relative' }}>
            <Chip style={{
              backgroundColor: '#c0c0c0',
              width:           '218px',
              height:          '218px',
              verticalAlign:   'bottom',
              margin:          '75px 0px -258px 40px',
            }}
            />

            {this.state.images
              && (
                <SortableMedia
                  maxHt={200}
                  minHt={200}
                  maxWd={200}
                  minWd={200}
                  listMargin={50}
                  images={this.state.images}
                  handleCrop={this.handleCrop}
                  handleView={this.handleView}
                  handleDelete={(mediaData) => this.handleConfirmation(mediaData)}
                  handleSort={this.handleSort}
                  listItemMargin="38px 48px"
                />
              )}
          </div>
        )}

        {this.state.view && (
          <Lightbox
            animationDisabled
            mainSrc={this.state.viewImage}
            onCloseRequest={() => {
              this.setState({
                view:      false,
                viewImage: null,
              });
            }}
          />
        )}

        <Dialog
          fullScreen
          open={this.state.openCropDialog}
          onClose={() => { this.handleClose(); }}
        >
          <FixedCropper
            width={4}
            height={3}
            cropPixelWidth={400}
            cropPixelHeight={400}
            outputPixelWidth={900}
            outputPixelHeight={900}
            type={this.state.type}
            url={this.state.uploadUrl}
            src={this.state.src}
            file={this.state.currentFile}
            handleSave={this.handleSave}
            handleClose={this.handleClose}
            isCropping={this.state.cropping}
          />
        </Dialog>

        <Dialog
          fullWidth
          size="sm"
          open={this.state.alert}
          onClose={() => { this.handleClose(); }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Remove Image</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete the image?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { this.handleClose(); }} color="primary">Cancel</Button>
            <Button onClick={() => { this.handleDelete(); }} color="primary">Confirm</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(useStyles)(Photos);

Photos.propTypes = {
  classes:  PropTypes.shape(Object),
  reviewId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  images:              PropTypes.arrayOf(PropTypes.shape(Object)),
  image:               PropTypes.string,
  onReviewImageChange: PropTypes.func,
  onImageChange:       PropTypes.func,
  onSortImage:         PropTypes.func,
};

Photos.defaultProps = {
  classes:             {},
  reviewId:            null,
  images:              [],
  image:               '',
  onReviewImageChange: () => {},
  onImageChange:       () => {},
  onSortImage:         () => {},
};
